import { Icon } from '@amelio/ui-library';
import { useId } from 'react';

import { GROWTH_PANEL_SURFACE } from '../GrowthTab/growthStyles';

import type { ComponentProps } from 'react';

import { NoteComposer } from '@/components/EmployeeNotes/NoteComposer';

interface NoteComposerCardProps extends ComponentProps<typeof NoteComposer> {
    /** Names the card and the region it opens, e.g. "Add a note". */
    heading: string;
}

/**
 * The composer of the "Notes" tab set apart as a card of its own: a titled header, then the
 * editor. Editing a note in place keeps the bare `NoteComposer` inside its card.
 */
export const NoteComposerCard = ({ heading, ...composerProps }: NoteComposerCardProps) => {
    const headingId = useId();

    return (
        <section
            aria-labelledby={headingId}
            className={GROWTH_PANEL_SURFACE}
        >
            <div className={'flex flex-col gap-4 p-4 md:p-6'}>
                <div className={'flex items-center gap-2'}>
                    <span
                        className={
                            'from-turquoise-deep to-step-rail-turquoise flex size-[32px] items-center justify-center rounded-lg bg-gradient-to-br text-white shadow-sm'
                        }
                    >
                        <Icon
                            name={'edit-document-text'}
                            size={16}
                            color={'inherit'}
                            ariaHidden
                        />
                    </span>
                    <h4
                        id={headingId}
                        className={'text-navy text-[14px] font-semibold'}
                    >
                        {heading}
                    </h4>
                </div>

                <NoteComposer {...composerProps} />
            </div>
        </section>
    );
};
